import { reactive } from "vue"

export const AccountStore = function () {
    const state = reactive({
        profile: null
    })

    const getters = {
        getRawPoint: function () {
            if (state.profile) {
                if (state.profile.updated_points?.points != null) {
                    let points = state.profile.updated_points.points
                    state.point = points
                    return state.point;
                }
                return 0
            } else {
                return 0;
            }
        },
    }

    const setters = {
        setProfile: function (profile) {
            state.profile = profile
        }
    }

    return {
        state,
        getters,
        setters,
    }
}

export default AccountStore
